const API_BASE_URL = "https://api.stratxcel.ai";
// const API_BASE_URL = "http://127.0.0.1:8000";
export { API_BASE_URL };
export const GOOGLE_CLIENT_ID =
  "893140063990-12pb71oqduf4ooj5l9842ojlo4ec2jk2.apps.googleusercontent.com";


export const OPENCAGE_API_KEY = "15cdbb25f5ab4b128b75cb3465738406";

export const TWOFACTOR_API_KEY = "1f99185a-30a8-11f0-8b17-0200cd936042";
